export const groupPurposesBySection = (purposes) => {
    return purposes.reduce((acc, currentPurpose) => {
        const sectionPurpose = acc.find((purpose) => purpose.purposeId === currentPurpose.section.id);
        const preparedPurposeData = {
            ...currentPurpose,
            purposeName: currentPurpose.name,
            purposeDescription: currentPurpose.description,
        };
        if (sectionPurpose) {
            sectionPurpose.purposes.push(preparedPurposeData);
        }
        else {
            acc.push({
                purposeTitle: currentPurpose.section.name,
                purposeDescription: currentPurpose.section.description,
                purposeId: currentPurpose.section.id,
                purposes: [preparedPurposeData],
            });
        }
        return acc;
    }, []);
};
//# sourceMappingURL=purposes.js.map